module.exports = __webpack_public_path__ + "static/media/logo.cfce3dab.png";